import { Controller } from "@hotwired/stimulus"
import { formatPln, getJSON } from "../api.js"

// Pulpit operatora: kafelki z GET /api/reports/summary/ (tylko personel).
export default class extends Controller {
  static targets = ["status", "revenue", "ordersPaid", "complaintsOpen", "creditsTotal",
                    "listingsTotal", "availableCount", "reservedCount", "soldCount",
                    "availableBar", "reservedBar", "soldBar",
                    "delivered", "deliveriesPending", "deliveriesFailed", "refunded",
                    "marginRevenue", "marginCost", "marginNet", "leadsWithoutCost"]
  static values = { url: String } // /api/reports/summary/

  connect() { this.load() }

  async load() {
    let summary
    try {
      summary = await getJSON(this.urlValue)
    } catch {
      this.#status("Nie udało się załadować danych. Odśwież stronę.")
      return
    }
    this.#status(null)

    const { sales, inventory, complaints, credits, deliveries } = summary
    this.revenueTarget.textContent = formatPln(sales.revenue_gross_pln)
    this.ordersPaidTarget.textContent = sales.orders_paid
    this.complaintsOpenTarget.textContent = complaints.open
    this.creditsTotalTarget.textContent = formatPln(credits.total_pln)

    this.listingsTotalTarget.textContent = inventory.listings_total
    const total = inventory.listings_total || 1
    const fill = (countTarget, barTarget, count) => {
      countTarget.textContent = count
      barTarget.style.width = `${Math.round((count / total) * 100)}%`
    }
    fill(this.availableCountTarget, this.availableBarTarget, inventory.available)
    fill(this.reservedCountTarget, this.reservedBarTarget, inventory.reserved)
    fill(this.soldCountTarget, this.soldBarTarget, inventory.sold)

    this.deliveredTarget.textContent = deliveries.delivered
    this.deliveriesPendingTarget.textContent = deliveries.pending
    this.deliveriesFailedTarget.textContent = deliveries.failed
    this.refundedTarget.textContent =
      `${sales.orders_refunded} · ${formatPln(sales.refunded_gross_pln)}`

    // Marża (Slice C): przychód netto − koszt DISTINCT/lead. Guard: starszy backend bez `margin`.
    const { margin } = summary
    if (margin) {
      if (this.hasMarginRevenueTarget) this.marginRevenueTarget.textContent = formatPln(margin.revenue_net_pln)
      if (this.hasMarginCostTarget) this.marginCostTarget.textContent = formatPln(margin.cost_net_pln)
      if (this.hasMarginNetTarget) this.marginNetTarget.textContent = formatPln(margin.margin_net_pln)
      if (this.hasLeadsWithoutCostTarget) this.leadsWithoutCostTarget.textContent = margin.leads_without_cost
    }
  }

  #status(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.hidden = message === null
    if (message !== null) this.statusTarget.textContent = message
  }
}
